import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, forkJoin, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export interface ComiteIntegrante {
  id?: string | number;
  numeroComite?: number;
  cedula: string | number;
  nombre: string;
  cargoLaboral?: string;
  // ahora puede ser string o array de strings (descripciones)
  funcion: string | string[];
  // nuevo: detalle formateado que se guardará en BD
  funciones_det?: string | null;
  n_funcion?: number | null; // ID numérico de la función para el selector de detalles
  n_detalle?: number | null; // ID numérico del detalle seleccionado por integrante
  motivo?: number | null;
  documento?: number | null;
}


export interface ComiteRegistro {
  numeroComite?: number;
  cedula: number;
  nombre: string;
  cargoLaboral: string;
  funcion: string;
  estado?: number;
  motivo?: number | null;
  observaciones?: string | null;
  documento?: number | null;
}

export interface ComiteResponse {
  id?: string;
  cedula?: number;
  nombre?: string;
  cargoLaboral?: string;
  funcion?: string;
  estado?: number;
  fechaCreacion?: string;
  fechaModificacion?: string;
  motivo?: number | null;
  observaciones?: string | null;
  documento?: number | null;

  // 🔹 NUEVO
  diasParaRenovar?: number;
}


@Injectable({
  providedIn: 'root'
})
export class ComiteService {
  private apiUrl = `${environment.apiUrl}/api/comite`;

  constructor(private http: HttpClient) {

  }

  /**
   * Obtener todos los comités
   */
  getAll(): Observable<ComiteResponse[]> {
    return this.http.get<ComiteResponse[]>(`${this.apiUrl}`, { withCredentials: true });
  }

  getAllActivos(): Observable<ComiteResponse[]> {
    return this.http.get<ComiteResponse[]>(`${this.apiUrl}/activos`, { withCredentials: true });
  }

  /**
   * Obtener comité por ID
   */
  getById(id: string): Observable<ComiteResponse> {
    return this.http.get<ComiteResponse>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  /**
   * Crear nuevo registro de comité
   */
  create(comite: ComiteRegistro): Observable<ComiteResponse> {
    const url = `${this.apiUrl}`;
    //console.log(`🚀 POST request to: ${url}`, comite);
    return this.http.post<ComiteResponse>(url, comite, { withCredentials: true });
  }

  /**
   * Actualizar comité existente
   */
  update(id: string, comite: ComiteRegistro): Observable<ComiteResponse> {
    console.log(`Updating comité with ID: ${id}`, comite);
    return this.http.put<ComiteResponse>(`${this.apiUrl}/${id}`, comite);
  }

  /**
   * Inactivar comité (requiere motivo y observaciones)
   */
  inactivar(id: number, payload: { motivo: number; observaciones: string }): Observable<any> {
    console.log(`Inactivating comité with ID: ${id}`, payload);
    return this.http.put(`${this.apiUrl}/inactivar/${id}`, payload);
  }

  /**
   * Activar un comité inactivo
   */
  activar(id: number, payload?: { motivo?: number; observaciones?: string }): Observable<any> {
    return this.http.put(`${this.apiUrl}/activar/${id}`, payload || {});
  }

  /**
   * Guardar múltiples integrantes al comité (crea un registro por cada integrante)
   */
guardarIntegrantes(numeroComite: number, integrantes: ComiteIntegrante[]): Observable<any> {
  const payload = {
    numeroComite: Number(numeroComite),
    integrantes: integrantes.map(integrante => ({
      cedula: Number(integrante.cedula),
      nombre: integrante.nombre,
      cargoLaboral: integrante.cargoLaboral || '',
      funcion: integrante.funcion,            // puede ser array o string
      funciones_det: integrante.funciones_det ?? null,
      estado: 1,
      documento: integrante.documento ?? null
    }))
  };

  const url = `${this.apiUrl}/guardar-integrantes`;
  return this.http.post<any>(url, payload, { withCredentials: true });
}

/**
 * Crear múltiples integrantes (compatibilidad con createBatch)
 * Recibe payload: { numeroComite: number, integrantes: ComiteIntegrante[] }
 */
createBatch(payload: { numeroComite: number; integrantes: ComiteIntegrante[] }) {
  const url = `${this.apiUrl}/guardar-integrantes`;
  return this.http.post<any>(url, payload, { withCredentials: true });
}


}

